var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#23A26D",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9243 13.0952C18.3648 13.0952 13.0195 18.4405 13.0195 25C13.0195 31.5595 18.3648 36.9047 24.9243 36.9047C31.4838 36.9047 36.8291 31.5595 36.8291 25C36.8291 18.4405 31.4838 13.0952 24.9243 13.0952ZM30.6148 22.2619L23.8648 29.0119C23.6981 29.1785 23.4719 29.2738 23.2338 29.2738C22.9957 29.2738 22.7695 29.1785 22.6029 29.0119L19.2338 25.6428C18.8886 25.2976 18.8886 24.7262 19.2338 24.3809C19.5791 24.0357 20.1505 24.0357 20.4957 24.3809L23.2338 27.119L29.3529 21C29.6981 20.6547 30.2695 20.6547 30.6148 21C30.96 21.3452 30.96 21.9047 30.6148 22.2619Z",
    fill: "#23A26D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.46dde2794b796d37b6b940e93eef9fe5.svg";
export { ForwardRef as ReactComponent };